import { createReducer } from '@reduxjs/toolkit';

import { selectStep } from 'modules/loading-screen/contents/actions';
import { startUpload, updateUploadProgress, finishUpload } from './actions';
import { FilesUploadsState, FileUploadProgress } from './typings';

const initialState: FilesUploadsState = {
  inProgress: false,
  uploads: {},
};

export default createReducer(initialState, (builder) => {
  return builder
    .addCase(startUpload, (state, action) => ({
      ...state,
      inProgress: true,
      failed: false,
      errorMessage: undefined,
      isNetworkError: false,
      uploads: {
        ...state.uploads,
        [action.payload.id]: {
          id: action.payload.id,
          inProgress: true,
          fileName: action.payload.file.name,
          progress: 0,
          failed: false,
          errorMessage: undefined,
          isNetworkError: false,
        },
      },
    }))
    .addCase(updateUploadProgress, (state, action) => ({
      ...state,
      inProgress: Object.values(state.uploads).every((upload) =>
        upload.id !== action.payload.id
          ? upload.inProgress
          : !action.payload.failed,
      ),
      errorMessage: action.payload.errorMessage,
      isNetworkError: action.payload.isNetworkError,
      uploads: {
        ...state.uploads,
        [action.payload.id]: {
          ...state.uploads[action.payload.id],
          progress: action.payload.progress,
          inProgress: !action.payload.failed,
          failed: action.payload.failed,
          errorMessage: action.payload.errorMessage,
          isNetworkError: action.payload.isNetworkError,
        },
      },
    }))
    .addCase(finishUpload, (state) => {
      // Preserve upload errors so they can be displayed in components
      const failedUploads: Record<string, FileUploadProgress> = {};
      Object.values(state.uploads).forEach((upload) => {
        if (upload.failed) {
          failedUploads[upload.id] = {
            ...upload,
            inProgress: false,
          };
        }
      });
      
      return {
        ...initialState,
        uploads: failedUploads,
        failed: Object.keys(failedUploads).length > 0,
        errorMessage: Object.values(failedUploads)[0]?.errorMessage,
        isNetworkError: Object.values(failedUploads)[0]?.isNetworkError ?? false,
      };
    })
    .addCase(selectStep, () => initialState);
});
